module.exports = __webpack_public_path__ + "assets/img/code7.05045b53.png";